import PolicyLayout from "@/components/site/PolicyLayout";
import Seo from "@/components/site/Seo";
import { BUSINESS } from "@/lib/siteData";

export default function Refund() {
  return (
    <PolicyLayout title="Refund Policy" lastUpdated="January 2026" testId="refund-page">
      <Seo
        title="Refund Policy"
        description="Repair Point refund policy — diagnostic refunds, no-fix-no-fee guarantee, remote-support refunds and 30-day workmanship warranty terms."
        path="/refund"
      />
      <h2 className="font-heading text-xl font-semibold">1. Our commitment</h2>
      <p>
        We aim for every customer to leave satisfied. If you are not happy with a repair, contact us within
        30 days of completion and we will work with you to make it right.
      </p>

      <h2 className="font-heading text-xl font-semibold">2. Diagnostic fee refunds</h2>
      <p>
        The $49 diagnostic fee is fully refundable if you proceed with the recommended repair on the same day.
        If you choose not to proceed, the fee covers the technician&rsquo;s time and is non-refundable.
      </p>

      <h2 className="font-heading text-xl font-semibold">3. Repair fee refunds</h2>
      <ul className="list-disc pl-6 space-y-1.5">
        <li>
          <strong>No-fix-no-fee:</strong> if we cannot resolve the specific issue you booked, your labour
          fee is fully refunded.
        </li>
        <li>
          <strong>Recurring fault:</strong> if the same fault returns within 30 days, we will re-perform the
          repair at no labour cost. If it cannot be resolved, the original labour fee is refunded.
        </li>
        <li>
          <strong>Parts:</strong> defective parts are replaced under manufacturer warranty. Refunds on parts
          are subject to the manufacturer&rsquo;s warranty terms.
        </li>
      </ul>

      <h2 className="font-heading text-xl font-semibold">4. Remote support refunds</h2>
      <p>
        If a remote support session fails to resolve your issue, the session fee will be refunded in full.
      </p>

      <h2 className="font-heading text-xl font-semibold">5. How to request a refund</h2>
      <p>
        Email {BUSINESS.email} or call {BUSINESS.phone} with your invoice number and a brief description of
        the issue. Approved refunds are processed to the original payment method within 7 business days.
      </p>

      <h2 className="font-heading text-xl font-semibold">6. Exclusions</h2>
      <p>
        Refunds do not apply to damage caused after the repair was completed, to software issues unrelated to
        the original booking, or where the customer has modified the repaired hardware.
      </p>

      <h2 className="font-heading text-xl font-semibold">7. Independent service disclaimer</h2>
      <p>
        {BUSINESS.name} is an independent third-party computer repair service. We are not affiliated with,
        endorsed by, or sponsored by Microsoft, Apple, or any other brand referenced on this site.
      </p>
    </PolicyLayout>
  );
}
